<template>
  <a-modal
    title="设置权益"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    destroyOnClose
    :maskClosable="false"
    width="700px"
  >
    <a-spin :spinning="loading">
      <a-descriptions :column="2" bordered size="small" class="mb-16">
        <a-descriptions-item label="会员名称">{{ vipInfo.vip_name || '-' }}</a-descriptions-item>
        <a-descriptions-item label="价格">{{ vipInfo.vip_price || '-' }}</a-descriptions-item>
        <a-descriptions-item label="原价">{{ vipInfo.vip_price2 || '-' }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ vipInfo.create_time || '-' }}</a-descriptions-item>
      </a-descriptions>

      <a-divider>权益设置</a-divider>

      <a-table
        :columns="columns"
        :data-source="benefitList"
        :pagination="false"
        :rowKey="record => record.id"
        :scroll="{ y: 300 }"
        size="small"
      >
        <template slot="selected" slot-scope="text, record">
          <a-checkbox
            :checked="isSelected(record.id)"
            @change="e => handleCheckChange(e, record)"
          />
        </template>
        <template slot="quantity" slot-scope="text, record">
          <a-input-number
            v-if="isSelected(record.id)"
            v-model="selectedBenefits[record.id]"
            :min="1"
            :max="999"
            size="small"
            style="width: 80px"
          />
          <span v-else>-</span>
        </template>
      </a-table>
    </a-spin>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      loading: false,
      vipId: "",
      vipInfo: {},
      benefitList: [],
      selectedBenefits: {},
      columns: [
        {
          title: "选择",
          dataIndex: "selected",
          width: 60,
          scopedSlots: { customRender: "selected" },
        },
        {
          title: "权益名称",
          dataIndex: "name",
          width: 200,
        },
        {
          title: "数量",
          dataIndex: "quantity",
          width: 100,
          scopedSlots: { customRender: "quantity" },
        },
      ],
    };
  },
  methods: {
    init(vipId) {
      this.visible = true;
      this.vipId = vipId;
      this.selectedBenefits = {};
      this.vipInfo = {};
      this.loadVipInfo();
      this.loadBenefitList();
      this.loadVipBenefits();
    },
    loadVipInfo() {
      this.$http({
        url: "/admin/viplist/info",
        method: "post",
        data: {
          id: this.vipId,
        },
      }).then((res) => {
        this.vipInfo = res.data || {};
      });
    },
    loadBenefitList() {
      this.loading = true;
      this.$http({
        url: "/admin/benefittag/list",
        method: "get",
      })
        .then((res) => {
          this.benefitList = res.data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadVipBenefits() {
      this.$http({
        url: "/admin/benefittag/getVipBenefits",
        method: "post",
        data: {
          vip_id: this.vipId,
        },
      }).then((res) => {
        if (res.data && res.data.benefits) {
          res.data.benefits.forEach((item) => {
            this.selectedBenefits[item.benefit_tag_id] = item.quantity || 1;
          });
        }
      });
    },
    isSelected(benefitId) {
      return this.selectedBenefits.hasOwnProperty(benefitId);
    },
    handleCheckChange(e, record) {
      if (e.target.checked) {
        this.$set(this.selectedBenefits, record.id, 1);
      } else {
        this.$delete(this.selectedBenefits, record.id);
      }
    },
    handleOk() {
      const benefits = Object.keys(this.selectedBenefits).map((benefitTagId) => ({
        benefit_tag_id: parseInt(benefitTagId),
        quantity: this.selectedBenefits[benefitTagId] || 1,
      }));

    //   if (benefits.length === 0) {
    //     this.$message.warning("请至少选择一个权益");
    //     return;
    //   }

      this.confirmLoading = true;
      this.$http({
        url: "/admin/benefittag/setVipBenefits",
        method: "post",
        data: {
          vip_id: this.vipId,
          benefits: benefits,
        },
      })
        .then(() => {
          this.$message.success("设置成功");
          this.handleCancel();
          this.$emit("ok");
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.benefitList = [];
      this.selectedBenefits = {};
      this.vipInfo = {};
    },
  },
};
</script>

<style scoped>
.mb-16 {
  margin-bottom: 16px;
}
</style>
